<template>
    <!--头部按钮列表-->
    <div class="bg_fff pt10 pb10 pl15 pr15 flex space-between">
        <el-row>
            <el-button v-if="orderType ==='CHINESE_RECIPE'"
                       type="primary" plain size="medium"
                       @click="handler('添加中药方')">添加中药方
            </el-button>
            <el-button v-if="orderType ==='WESTERN_RECIPE'"
                       type="primary" plain  size="medium"
                       @click="handler('添加西药方')">添加西药方
            </el-button>
            <el-button v-if="!subStatus" type="primary" plain size="medium"
                       @click="handler('导入处方')">导入处方</el-button>
            <el-button plain size="medium" type="primary"
                       @click="handler('添加至常用方')">添加至常用方</el-button>
            <el-button v-if="source!=='PrescriptionList'" plain size="medium" type="primary"
                       @click="handler('查看订单详情')">查看申请处方详情</el-button>
            <!--<el-button type="primary" v-if="subStatus" plain size="mini"
                        @click="doPrint">打印处方</el-button>-->
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "recipe-head-btn",
        data(){
            return{
                subStatus: false,
            }
        },
        props:{
            orderType: '',
            sub: '',
            end: Boolean,
            source: String,
        },
        methods: {
            handler(name, type){
                this.$emit('handler', name, type)
            },
        },
        watch:{
            end:{
                handler(newV){
                    this.subStatus = newV
                },
                immediate:true
            }
        }
    }
</script>

<style scoped>

</style>